<template>
  <div id="disease-case">
    <ul class="service-list">
      <li class="item" v-for="item of list" :key="item.id">
        <div class="item-img">
          <img :src="item.imgUrl" alt="" />
        </div>
        <div class="item-detail">
          <div class="detail-title">{{ item.title }}</div>
          <div class="detail-location">
            <span class="country iconfont">&#xe650;</span>
            <span class="location">{{ item.location }}</span>
            <span class="disease iconfont">&#xe65c;</span>
            <span class="location">{{ item.disease }}</span>
          </div>
          <p class="detail-line"></p>
          <div class="hospital">
            就诊医院：<span class="inner">{{ item.hospital }}</span>
          </div>
          <div class="effect">
            就诊疗效： <span class="inner">{{ item.effect }}</span>
          </div>
        </div>
      </li>
    </ul>
    <div class="paging">
      <el-pagination
        small
        background
        layout="prev, pager, next"
        :total="1000"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "DiseaseCase", // 疾病案例
  components: {},
  data() {
    return {
      list: [
        {
          id: 1,
          title: "特罗凯失效后，第三代靶向药让肺癌晚期患者逃过“死神”",
          location: "美国",
          disease: "肺癌",
          hospital: "哈佛大学医学院教学附属丹娜法伯癌症研究院 ",
          effect:
            "首先参加了厄洛替尼临床试验，肿瘤缩小了。耐药过后又参加了EGFR突变抑制剂AZD9291临床试验，不仅延长了生命，而且显著提高。",
          imgUrl: require("../../../../assets/images/blueCross/1.png")
        },
        {
          id: 2,
          title: "“患癌家族”三人因癌症去世，新型免疫疗法却让他活了下来",
          location: "美国",
          disease: "肺癌",
          hospital: "哈佛大学医学院教学附属丹娜法伯癌症研究院 ",
          effect:
            "在临床试验中使用新的免疫检查点抑制剂进行治疗后，肿瘤缩小了25%。",
          imgUrl: require("../../../../assets/images/blueCross/2.png")
        },
        {
          id: 3,
          title: "美国患者成功战胜三种癌症",
          location: "美国",
          disease: "结直肠癌",
          hospital: "MD安德森癌症中心 ",
          effect:
            "进行了结肠和肝脏右叶的手术切除术，并接受了化疗，成功地抑制了肿瘤的生长。 ",
          imgUrl: require("../../../../assets/images/blueCross/3.png")
        }
      ]
    };
  },
  mounted() {

  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
#disease-case {
  width: 100%;
  margin-top: 20px;
  .service-list {
    .item {
      height: 170px;
      width: 100%;
      margin-top: 20px;
      display: flex;
      .item-img {
        width: 35%;
        height: 100%;
        background: #d2d2d2;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .item-detail {
        margin-left: 18px;
        width: 65%;
        .detail-title {
          color: #3b3b3b;
          font-size: 16px;
          line-height: 34px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .detail-location {
          .iconfont {
            color: #3496e3;
            margin-right: 10px;
          }
          .location {
            color: #525252;
            margin-right: 35px;
          }
        }
        .detail-line {
          width: 100%;
          border-bottom: 1px solid #d4d4d4;
          margin: 15px 0;
        }
        .hospital {
          font-size: 14px;
          line-height: 18px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #3a3a3a;
          .inner {
            color: #a3a3a3;
          }
        }
        .effect {
          margin-top: 18px;
          font-size: 14px;
          line-height: 18px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          color: #3a3a3a;
          .inner {
            color: #a3a3a3;
          }
        }
      }
    }
  }
  .paging {
    margin-top: 15px;
  }
}
</style>
